import { Box, Chip, Grid } from "@mui/material";
import { useContent } from "../../content/useContent";
import { useRTL } from "../../hooks/useLanguage/useRTL";
import { getDateWithoutSeconds } from "../../utils/getDateWithoutSeconds";
import { eventCategoriesAr } from "../../utils/translations";
import { translator } from "../../utils/translations/translator";
import ImageList from "../ImageList";
import Info from "../Info";
import Map from "../Map";
import Title from "../Title";

type IProps = {
  event: any;
};

const Single: React.FC<IProps> = ({ event }) => {
  const { isRTL } = useRTL();
  const { events } = useContent().pages;

  return (
    <>
      <Title title={`${events.event} - ${event.title}`} />
      <Grid container>
        <Grid item xs={12} md={6}>
          <Info title={events.details} description={event.details} />
        </Grid>
        <Grid item xs={12} md={6}>
          <Info
            title={events.category}
            description={
              isRTL
                ? translator(event.category, eventCategoriesAr)
                : event.category
            }
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Info
            title={events.partnerCode}
            description={event.partnerCode || "-"}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Info
            title={events.loyaltyCategory}
            description={event.loyaltyCategory}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <Info
            title={events.publishDate}
            description={`${getDateWithoutSeconds(event.publishDate)}`}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <Info
            title={events.startDate}
            description={`${getDateWithoutSeconds(event.startDate)}`}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <Info
            title={events.endDate}
            description={`${getDateWithoutSeconds(event.endDate)}`}
          />
        </Grid>

        <Grid item xs={12}>
          <Info title={events.eventLocation} />
        </Grid>
        <Grid item xs={12}>
          <Map
            center={{ lat: event.latitude, lng: event.longitude }}
            zoom={10}
            sx={{ height: "400px" }}
            draggable={false}
            markers={[
              {
                pos: { lat: event.latitude, lng: event.longitude },
              },
            ]}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <Info title={events.lat} description={event.latitude} />
        </Grid>

        <Grid item xs={12} md={6}>
          <Info title={events.lng} description={event.longitude} />
        </Grid>

        <Grid item xs={12}>
          <Info title={events.images} />
          <ImageList images={event.images} />
        </Grid>

        <Grid item xs={12}>
          <Info title={events.prices} />
          <Box sx={{ display: "flex" }}>
            {event.prices.map((price: any) => (
              <Chip
                key={price.title}
                sx={{ mr: 1 }}
                label={`${price.title}: ${price.price}`}
                color="primary"
              />
            ))}
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default Single;
